import React from 'react';
import { translate } from 'react-i18next';
import CouponCodeWithLabel from './CouponCodeWithLabel';
import Checkbox from 'material-ui/Checkbox';

class CouponCode extends React.Component {

  render()  {
    const {t} = this.props;

    const couponCodeTag = this.props.couponCode ?
      <CouponCodeWithLabel code={this.props.couponCode}/>
      : null;

    return (
      <div className='col-xs col-md-7'>
        <span className='headerSpanStyle'>
          {t('offer.couponCode')}
        </span>
        <Checkbox
          label={t('offer.offerUsedWithCoupon')}
          checked={this.props.couponCodeUse}
          onCheck={this.props.handleCouponCodeUseChange}
          className='switchButton'
        />
        {couponCodeTag}
      </div>
    );
  }

}

export default translate()(CouponCode);



// WEBPACK FOOTER //
// ./src/Offer/CouponCode.js